import { APICore } from "./apiCore";

const api = new APICore();

// course
function addWhoAreWe(params: {
  experience: string;
  users: string;
  courses: string;
  file: any;
  head: string;
  subhead: string;
  head_ar: string;
  subhead_ar: string;
}) {
  
  
  const baseUrl = "/who_are_we_data";
  return api.createWithFile(`${baseUrl}`, params);
}

function getWhoAreWe() {
  const baseUrl = "/who_are_we_data";
  return api.get(`${baseUrl}`, {});
}

function updateWhoAreWe(
  id: number,
  params: {
    experience: string;
    users: string;
    courses: string;
    file: any;
    head: string;
    subhead: string;
    head_ar: string;
    subhead_ar: string;
  }
) {
  const baseUrl = `/who_are_we_data/${id}`;
  return api.updateWithFile(`${baseUrl}`, params);
}

function deleteWhoAreWe(id: number) {
  const baseUrl = `/who_are_we_data/${id}`;
  return api.delete(`${baseUrl}`);
}

export { addWhoAreWe, deleteWhoAreWe, getWhoAreWe, updateWhoAreWe };
